import React from 'react'
import cmp1 from '../../../Assets/trustedCmp1.png'
import cmp2 from '../../../Assets/trustedCmp2.png'
import cmp3 from '../../../Assets/trustedCmp3.png'
import cmp4 from '../../../Assets/trustedCmp4.png'
import cmp5 from '../../../Assets/trustedCmp5.png'
import cmp6 from '../../../Assets/trustedCmp6.png'
import cmp7 from '../../../Assets/trustedCmp7.png'
import cmp8 from '../../../Assets/trustedCmp8.png'
import rightArrow from '../../../Assets/arrowRight.png'
import ceo from '../../../Assets/ceo.png'
import planet from '../../../Assets/planet.png'
import customerSupport from '../../../Assets/customerSupport.png'
import doodle from '../../../Assets/doodle.png'
import customerCareBg from '../../../Assets/customerSupportVector.svg'


import './TrustedBy.css'

let cmpArr = [cmp1, cmp2, cmp3, cmp4, cmp5, cmp6, cmp7, cmp8];
// console.log(cmpArr)

const CustomerSupport = () => {
    return (
        <div className="customerSupportContainer">

            <div className="supportLeft">
                <h2 className="customerSupportHeading">Customers love our support team, and so will you?</h2>
                <div className="customerSupportActions">
                    <a href="">
                        <div className="scheduleDemo">
                            Schedule a Demo
                            <img src={rightArrow} alt="" />
                        </div>
                    </a>
                    <a href="" className="peopleReview">
                        Why People love them
                    </a>
                </div>
                <div className="ceoComment">
                    <p className="ceoWords">"Customers have shown great appreciation for our support team, and I'm confident you'll experience the same level of satisfaction."</p>
                    <div className="ceo">
                        <img src={ceo} alt="ceo image" />
                        Lana del rey,&nbsp;<span>CEO of Nidaan</span>
                    </div>
                </div>
            </div>

            <div className="supportRight">
                {/* <div className="supportVectorContainer"> */}
                {/* <img src={customerSupport} alt="Customer Care" className='customerSupportImg' />
                    <img src={doodle} alt="Vector Art" className='doodleVector' />
                    <img src={planet} alt="Vector Art" className='planetVector' />
                    <div className="customerSupportText">Hi Lisa, is there anything i can help you today?</div> */}

                <img src={customerCareBg} alt="" loading='lazy' />
                {/* </div> */}
            </div>

        </div>
    )
}

const TrustedBy = () => {
    return (
        <div className='trustedBy'>
            <div className='trustedByContainer'>
                <h2 className="trustedHeading">Trusted by</h2>
                <p className="trustedSubHeading">230+ Companies & Influencers from all over India</p>

                {/* ADD ANIMATION */}
                <div className="trustedCmpContainer">
                    <img src={cmp1} alt="company logo" className='trustedCompanyLogo' />
                    <img src={cmp2} alt="company logo" className='trustedCompanyLogo' />
                    <img src={cmp3} alt="company logo" className='trustedCompanyLogo' />
                    <img src={cmp4} alt="company logo" className='trustedCompanyLogo' />
                    <img src={cmp5} alt="company logo" className='trustedCompanyLogo' />
                    <img src={cmp6} alt="company logo" className='trustedCompanyLogo' />
                    <img src={cmp7} alt="company logo" className='trustedCompanyLogo' />
                    <img src={cmp8} alt="company logo" className='trustedCompanyLogo' />
                </div>

            </div>

            <CustomerSupport />
        </div>
    )
}

// function insertLogos() {
//     const logoContainer = document.querySelector('.trustedCmpContainer');

//     var cluster = '';

//     cmpArr.forEach((logo) => {
//         console.log(logo);
//         cluster += `<img src={${logo}} alt="company logo" className='trustedCompanyLogo'/>`
//     });
//     // console.log(cluster);

//     logoContainer.innerHTML = cluster;
// }
export default TrustedBy;